export { default } from './TaulaExtrems';
